import React, { useState } from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

// Import configs and util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import { formatPossessiveCategory } from '../../../../util/string';

import { types as sdkTypes } from '../../../../util/sdkLoader';
import ToggleButton from 'react-toggle-button';
// Import shared components
import { Button, FieldTextInput, Form, IconSpinner, TypeButtons } from '../../../../components';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
// Import modules from this directory
import css from './MeasureMentForm.module.css';

import SizeButtons from '../../../../components/SizeButtons/SizeButtons';
import BackModal from '../../../../components/BackModal/BackModal';

import W1 from '../../../../assets/Photos/W1.jpg';
import W2 from '../../../../assets/Photos/W2.jpg';
import W3 from '../../../../assets/Photos/W3.jpg';
import W4 from '../../../../assets/Photos/W4.jpg';
import W5 from '../../../../assets/Photos/W5.jpg';

import M1 from '../../../../assets/Photos/M1.jpg';
import M2 from '../../../../assets/Photos/M2.jpg';
import M3 from '../../../../assets/Photos/M3.jpg';

import K1 from '../../../../assets/Photos/K1.jpg';
import K2 from '../../../../assets/Photos/K2.jpg';
const images = {
  W1: W1,
  W2: W2,
  W3: W3,
  W4: W4,
  W5: W5,
  M1: M1,
  M2: M2,
  M3: M3,
  K1: K1,
  K2: K2,
};
export const MeasureMentFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        values,
        form,
        subCategoryData,
        categoryLabel,
        type,
        colour,
        handleSaveListingDraft,
        saveDraftInProgress,
        handleBack,
        title,
      } = formRenderProps;
      const [showBackModal, setShowBackModal] = useState(false);
      const scrollWindow = () => {
        if (typeof window !== 'undefined') window.scrollBy(0, 350);
      };
      const details = formatPossessiveCategory(categoryLabel);
      const typeOptions = subCategoryData && subCategoryData?.type ? subCategoryData?.type : [];
      const colourOptions =
        subCategoryData && subCategoryData?.colour ? subCategoryData?.colour : [];
      const typeLabel = typeOptions.find(i => i.key == type) || subCategoryData;
      const typeImage = typeOptions.find(i => i.key == type)?.image || [];

      const colourLabel = colourOptions.find(i => i.key == colour)?.label;
      const sizeOptions = subCategoryData && subCategoryData?.size ? subCategoryData?.size : [];

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};
      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="MeasureMentForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="MeasureMentForm.showListingFailed" />
            </p>
          ) : null}
          <div className={css.content}>
            {details || typeLabel || colourLabel ? (
              <p className={css.details}>
                {title}
                {/* {details ? <span className={css.space}>{details}</span> : null}
                {colourLabel ? <span className={css.space}>{colourLabel}</span> : null}
                {typeLabel ? <span>{typeLabel?.sLabel || typeLabel?.label}</span> : null} */}
              </p>
            ) : null}
            <div className={css.datacontainer}>
              {typeImage?.length ? (
                <>
                  {' '}
                  <p className={css.cm}>
                    {intl.formatMessage(
                      {
                        id: 'EditListingMeasurementPanel.MeasureMentForm.measureMentInchesLabel',
                      },
                      { inches: <b>inches</b> }
                    )}
                    .
                  </p>
                  {typeImage?.map((data, index) => {
                    const { image, fields = [] } = data || {};

                    const imageSrc = images[image];
                    return (
                      <div className={css.container}>
                        <div className={css.fields}>
                          {fields.map(key => {
                            return (
                              <div key={key} className={css.formRow}>
                                <p className={css.label} htmlFor={`${key}_key`}>
                                  {key}
                                </p>
                                <FieldTextInput
                                  className={css.field}
                                  id={`${key}_key_${image}`}
                                  name={`${key}_key_${image}`}
                                  type="number"
                                />
                              </div>
                            );
                          })}
                        </div>
                        <div className={css.imagesContainer}>
                          <img key={index} src={imageSrc} alt="imageOne" className={css.imageOne} />
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : null}

              {sizeOptions?.length ? (
                <div className={css.lastContainer}>
                  <p className={css.cm}>
                    <b>
                      {intl.formatMessage({
                        id: 'EditListingMeasurementPanel.MeasureMentForm.productSizeLabel',
                      })}
                    </b>
                  </p>
                  <p className={css.cm}>
                    {intl.formatMessage({
                      id: 'EditListingMeasurementPanel.MeasureMentForm.productSizeSubCategory',
                    },
                    {YOU: <b>YOU</b>})}
                  </p>
                  <p className={css.cm}>
                    <FormattedMessage id="EditListingMeasurementForm.YouMaySelect" />
                  </p>
                  <SizeButtons
                    userTypeConfig={sizeOptions}
                    formValues={values}
                    name="size"
                    changeForm={type => {
                      scrollWindow();
                      form.change('size', type);
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <BackModal
            state={showBackModal}
            id="measurementFormBackModal"
            handleBack={() => handleBack('details')}
            loading={saveDraftInProgress}
            handleSaveThenClose={async () => {
              await handleSaveListingDraft(values);
              await handleBack('details');
            }}
          />
          <div className={css.bottonContainer}>
            <p className={css.saveDraft} onClick={() => handleSaveListingDraft(values)}>
              {saveDraftInProgress ? (
                <IconSpinner />
              ) : (
                intl.formatMessage({
                  id: 'EditListingFeaturesPanel.EditListingFeaturesForm.saveAsDraft',
                })
              )}
            </p>
            <div className={css.backContainer}>
              <Button
                className={css.submitButton}
                //  onClick={() => handleBack('details')}
                onClick={() => {
                  if (pristine) {
                    handleBack('details');
                  } else {
                    setShowBackModal(true);
                  }
                }}
              >
                {intl.formatMessage({
                  id: 'EditListingPricingAndStockPanel.EditListingPricingAndStockForm.back',
                })}
              </Button>
              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {saveActionMsg}
              </Button>
            </div>
          </div>
        </Form>
      );
    }}
  />
);

MeasureMentFormComponent.defaultProps = {
  fetchErrors: null,
  listingMinimumPriceSubUnits: 0,
  formId: 'MeasureMentForm',
};

MeasureMentFormComponent.propTypes = {
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  marketplaceCurrency: string.isRequired,
  unitType: string.isRequired,
  listingMinimumPriceSubUnits: number,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(MeasureMentFormComponent);
